import { createVNode as n, mergeProps as p } from "vue";
import m from "../node_modules/@pf-ui/pf-icon-svg/es/asn/JpgTwoTone.js";
import s from "../components/PfIcon.js";
const o = (r, e) => {
  const t = {
    ...r,
    ...e.attrs
  };
  return n(s, p(t, {
    icon: m
  }), null);
};
o.displayName = "JpgTwoTone";
o.inheritAttrs = !1;
export {
  o as default
};
